import {
	connect
} from 'react-redux'
import DataTable from '../components/common/DataTable.jsx';
// import {
// 	findSearchEpcList
// } from '../actions';

const mapStateToProps = (state) => ({
	data: state.getIn(['searchEpcListReducer', 'searchEpcList']),
	activePage: 1,
	itemPerPage: 100,
	totalPage: 1,
	pagingMaxButtons: 1,
	fields: {
		epc: 'EPC',
		order_label_id: '洗標條碼',
		serial_no: '洗標序號',
		order_id: '訂單編號',
		customer_gear_name: '項目',
		suit_serial_no: '項次',
		color_display: '顏色',
		sizing_display: '尺寸',
		manufacture_date: '製造日期',
		firefighter_corporation: '單位',
		firefighter_title_display: '警義消',
		firefighter_name: '姓名',
		bag_barcode: '標籤條碼',
	},
	keys: ['epc', 'order_label_id'],
	disableAdd: true,
	disableEdit: true,
	hidePaging: true
})

const mapDispatchToProps = (dispatch) => ({
	refresh: (payload) => {
		// dispatch(findSearchEpcList(payload));
	},
	changeActivepage: (pagingData) => {
		//不分頁，不處理
	}
})

const SearchEpcListListContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(DataTable)

export default SearchEpcListListContainer;


// WEBPACK FOOTER //
// ./src/containers/SearchEpcListContainer.jsx